// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3MluI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3MoZm"};